import { css, SerializedStyles } from "@emotion/react";
import { ReactTFC } from "../../../utils/fp/missing-ts-parts";
import { AssetType } from "@swo/shared";
import { CSS_MQ } from "../../../styles/breakpoints";
import { CSS_COLORS } from "../../../styles/styles-css-variables";
import { AspectRatio } from "../../../components/_shared-components/image-related/AspectRatio";
import { ContentfulImage2 } from "../../../components/_shared-components/image-related/ContentfulImage2";
import { NoImageSvg } from "../../../assets";
import React from "react";

const noImgStyles = css`
  margin-left: auto;
  margin-right: auto;

  display: flex;
  justify-content: center;
  align-items: center;
`;

export const LeftHandSideImage: ReactTFC<{ image: AssetType | undefined; attachStyles?: SerializedStyles }> = props => (
  <div
    css={[
      css`
        display: flex;
        justify-content: center;

        width: 75%;
        ${CSS_MQ.atLeastLg} {
          width: 50%;
        }

        margin-left: auto;
        margin-right: auto;

        img {
          width: 100%;
          max-height: 100%;
          object-fit: contain;
        }

        svg {
          width: 50%;
          height: 50%;
          object-fit: contain;
          ${CSS_COLORS.Grey2};
        }
      `,
      props.attachStyles,
    ]}
  >
    <AspectRatio
      height={1}
      width={1}
      attachStyles={css`
        width: 100%;
      `}
    >
      {props.image ? (
        <ContentfulImage2
          assetId={props.image.sys.id}
          contentfulUrl={props.image.url}
          withTransparency={true}
          cropping={undefined}
          sizes="(max-width: 700px) 100vw, 600px"
        />
      ) : (
        <NoImageSvg css={noImgStyles} strokeWidth={1} />
      )}
    </AspectRatio>
  </div>
);
